import { Box, Divider, Grid, Skeleton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  formatDateTime,
  formatDateToLongString,
} from "../../../../../helpers/methods";
import rahuTransitsStyles from "../RahuTransits.styles";

interface CustomProps {
  meanZodiac: any;
  trueZodiac: any;
  isLoading: boolean;
  selectedDate: string;
}

const Zodiac = (props: CustomProps) => {
  const classes = rahuTransitsStyles;
  const { t, i18n } = useTranslation();

  const getMeanRahu = () => {
    return (
      <Stack direction={"column"} alignItems={"center"} spacing={2}>
        <Box sx={classes.transitBox}>
          <Typography my={1} mx={1} sx={classes.contentText}>
            {t("rahuTranisiting")}{" "}
            <b>
              {props.meanZodiac.from_sign} (House {props.meanZodiac.from_house})
            </b>
          </Typography>
          <Typography my={1} mx={1} sx={classes.contentText}>
            <b>
              ({props.meanZodiac.nakshtra_name}, Pada {props.meanZodiac.pada})
            </b>{" "}
            on {formatDateToLongString(props.selectedDate, i18n.language)}
          </Typography>
        </Box>
        <Box sx={classes.transitBox}>
          {props.isLoading ? (
            <>
              <Skeleton variant="text" width="80%" height={50} sx={{ m: 1 }} />
              <Skeleton variant="text" width="60%" height={50} sx={{ m: 1 }} />
            </>
          ) : (
            <>
              <Typography my={1} mx={1} sx={classes.contentText}>
                From{" "}
                <b>
                  {props.meanZodiac?.from_sign} (House{" "}
                  {props.meanZodiac.from_house})
                </b>{" "}
                to{" "}
                <b>
                  {props.meanZodiac?.to_sign} (House {props.meanZodiac.to_house}
                  )
                </b>{" "}
              </Typography>
              <Typography mb={1} mx={1} sx={classes.contentText}>
                {formatDateTime(props.meanZodiac?.datetime, i18n.language)}
              </Typography>
            </>
          )}
        </Box>
      </Stack>
    );
  };

  const getTrueRahu = () => {
    return (
      <Stack direction={"column"} alignItems={"center"} spacing={2}>
        <Box sx={classes.transitBox}>
          <Typography my={1} mx={1} sx={classes.contentText}>
            True {t("rahuTranisiting")}{" "}
            <b>
              {props.meanZodiac.from_sign} (House {props.meanZodiac.from_house})
            </b>
          </Typography>
          <Typography my={1} mx={1} sx={classes.contentText}>
            <b>
              {" "}
              ({props.meanZodiac.nakshtra_name}, Pada {props.meanZodiac.pada})
            </b>{" "}
            on {formatDateToLongString(props.selectedDate, i18n.language)}
          </Typography>
        </Box>
        <Box sx={classes.transitBox}>
          {props.isLoading ? (
            <>
              <Skeleton variant="text" width="80%" height={50} sx={{ m: 1 }} />
              <Skeleton variant="text" width="60%" height={50} sx={{ m: 1 }} />
            </>
          ) : (
            <>
              <Typography my={1} mx={1} sx={classes.contentText}>
                From{" "}
                <b>
                  {props.trueZodiac?.from_sign} (House{" "}
                  {props.trueZodiac.from_house})
                </b>{" "}
                to{" "}
                <b>
                  {props.trueZodiac?.to_sign} (House {props.trueZodiac.to_house}
                  )
                </b>{" "}
              </Typography>
              <Typography mb={1} mx={1} sx={classes.contentText}>
                {formatDateTime(props.trueZodiac?.datetime, i18n.language)}
              </Typography>
            </>
          )}
        </Box>
      </Stack>
    );
  };

  const getZodiac = () => {
    return (
      <Grid container>
        <Grid item xl={6} lg={6} md={12} sm={12} xs={12} p={1}>
          <Stack direction={"column"} alignItems={"center"} spacing={2} pb={1}>
            <Typography sx={classes.transitHeader} px={2}>
              {t("rahuTransit")}
            </Typography>
            <Divider
              sx={{
                border: "1px solid rgba(255, 255, 255, 0.21)",
                width: "50%",
                height: "0px",
                mt: "2px !important",
                mb: "8px !important",
              }}
            />
          </Stack>
          {getMeanRahu()}
        </Grid>
        <Grid item xl={6} lg={6} md={12} sm={12} xs={12} p={1}>
          <Stack direction={"column"} alignItems={"center"} spacing={2} pb={1}>
            <Typography sx={classes.transitHeader} px={2}>
              {t("trueRahuTransit")}
            </Typography>
            <Divider
              sx={{
                border: "1px solid rgba(255, 255, 255, 0.21)",
                width: "50%",
                height: "0px",
                mt: "2px !important",
                mb: "8px !important",
              }}
            />
          </Stack>
          {getTrueRahu()}
        </Grid>
      </Grid>
    );
  };

  return getZodiac();
};

export default Zodiac;
